import { FilterValues } from "../../../data-model/filterValues";
import { FilterGroup } from "./buildNycbsSearchFilters";
import { buildNycbsOutcomeClassStructuredFilter } from "./buildNycbsOutcomeClassStructuredFilter";
import { NycbsExternalFilterKeys } from "./createFilterSections";
import { expandClientOutcomeFiltersToInternalStatuses } from "../table/utils/nycbsClientOutcome";

export interface ProcessedFilterData {
  filters: { [key: string]: string[] | null };
  structuredFilter?: FilterGroup;
  dateRange?: {
    startDate: string;
    endDate: string;
  };
}

/**
 * Converts sidebar filter selections into API filter field maps.
 *
 * @param validFilters - Active filter values from Redux for this table
 * @return ProcessedFilterData: Flat filters for the BigQuery API
 */
export const processFilterData = (
  validFilters: FilterValues[],
): ProcessedFilterData => {
  const filters: { [key: string]: string[] | null } = {};
  let structuredFilter: FilterGroup | undefined;

  if (!validFilters || validFilters.length === 0) {
    return { filters };
  }

  const filter = validFilters[0];

  if (!filter || !filter.values) {
    return { filters };
  }

  Object.entries(filter.values).forEach(([filterId, filterData]) => {
    const selectedValues = filterData.values || [];

    if (selectedValues.length > 0) {
      switch (filterId) {
        case NycbsExternalFilterKeys.DRUG:
          filters.drug = selectedValues;
          break;
        case NycbsExternalFilterKeys.PHARMACY_TYPE:
          filters.pharmacy_type = selectedValues;
          break;
        case NycbsExternalFilterKeys.OUTCOME:
          filters.response_status =
            expandClientOutcomeFiltersToInternalStatuses(selectedValues);
          break;
        case NycbsExternalFilterKeys.OUTCOME_CLASS: {
          const outcomeClassStructuredFilter =
            buildNycbsOutcomeClassStructuredFilter(selectedValues);

          if (outcomeClassStructuredFilter) {
            structuredFilter = outcomeClassStructuredFilter;
          } else {
            filters.pa_outcome_classification = selectedValues;
          }
          break;
        }
        case NycbsExternalFilterKeys.CASE_STATUS: {
          const includesOpen = selectedValues.includes("open");
          const includesClosed = selectedValues.includes("closed");

          if (includesOpen && includesClosed) {
            break;
          }

          if (includesClosed) {
            filters.sftp_status = ["success"];
          } else if (includesOpen) {
            filters.sftp_status = ["", "resubmit"];
          }
          break;
        }
        default:
          break;
      }
    }
  });

  return structuredFilter ? { filters, structuredFilter } : { filters };
};
